import React, { useState } from 'react';
import { User, UserRole } from '../../types';

interface ChangeRoleDialogProps {
  user: User;
  onConfirm: (userId: number, newRole: UserRole) => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ChangeRoleDialog: React.FC<ChangeRoleDialogProps> = ({
  user,
  onConfirm,
  onCancel,
  isLoading,
}) => {
  const [newRole, setNewRole] = useState<UserRole>(user.role);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onConfirm(user.id, newRole);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full p-6">
        <h2 className="text-xl font-bold mb-4">Rolle ändern</h2>
        <form onSubmit={handleSubmit}>
          <p className="text-gray-600 mb-4">
            Rolle für Benutzer <strong>{user.username}</strong> ändern:
          </p>

          <div className="mb-6">
            <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
              Neue Rolle
            </label>
            <select
              id="role"
              value={newRole}
              onChange={(e) => setNewRole(e.target.value as UserRole)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={isLoading}
            >
              <option value={UserRole.DOCTOR}>DOCTOR</option>
              <option value={UserRole.MANAGER}>MANAGER</option>
              <option value={UserRole.ADMIN}>ADMIN</option>
            </select>
          </div>

          <div className="flex gap-3">
            <button
              type="submit"
              disabled={isLoading || newRole === user.role}
              className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Wird geändert...' : 'Ändern'}
            </button>
            <button
              type="button"
              onClick={onCancel}
              disabled={isLoading}
              className="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeRoleDialog;
